import React from 'react';
import type { GroupBase, InputProps } from 'react-select';
import { components } from 'react-select';
import type { InvitationUserSelectOptionType } from './InvitationUserSelect';
import addTestId from '../utils/addTestId';

type InvitationUserSelectInputProps<
  OptionType extends InvitationUserSelectOptionType,
  IsMulti extends boolean = boolean,
  GroupType extends GroupBase<OptionType> = GroupBase<OptionType>,
> = InputProps<OptionType, IsMulti, GroupType> & {
  selectProps: InputProps<OptionType, IsMulti, GroupType>['selectProps'] & {
    onPaste?: (event: React.ClipboardEvent) => unknown;
  };
};

const InvitationUserSelectInput = <
  OptionType extends InvitationUserSelectOptionType,
  IsMulti extends boolean = boolean,
  GroupType extends GroupBase<OptionType> = GroupBase<OptionType>,
>(
  props: InvitationUserSelectInputProps<OptionType, IsMulti, GroupType>,
) => (
  <components.Input
    {...addTestId('invitationUserSelectInput')}
    {...props}
    onPaste={props.selectProps.onPaste}
  />
);

export default InvitationUserSelectInput;
